export default function (state = null, action) {
   const dontShowErrorTypeArr = [];
   const { type, error, payload } = action;

   if (type === "RESET_ERROR_MESSAGE") {
      return null;
   } else if (error && !(dontShowErrorTypeArr.some((val) => val === type))) {
      if (payload && payload.response) {
         return (payload.response.status !== 413 ? payload.response.data : "File size is too large. Please try compressing it and uploading again");
      }
      return "We are experiencing some technical issues. Please try again in a few moments";
   }

   return state;
}


// WEBPACK FOOTER //
// ./src/reducers/errorReducer.js